import React, { useEffect, useState, useRef } from "react";
import Layout from "../layouts/layout";
import { stripeCountries } from "../../data/stripe-countries";
import SelectElement from "../layouts/elements/fields/select_element";
import InputField from "../layouts/elements/fields/input";
import { useNavigate, Link } from "react-router-dom";
//import { ReactSession } from "react-client-session";
import { ReactSession } from "../../lib/secure_reactsession";
import { getTesterCreditSummaryService } from "../../services/credits";
import {
    updatetesterbankdetails,
    gettesterbankdetails,
    requesttesterpayout,
    getLoadMoreWalletHistory,
    deletetesterbankdetails,
    getProfile,
} from "../../services/user";
import { bankdetailsCountries } from "../../data/countries_bankdetails";
import TextAreaField from "./../layouts/elements/fields/textarea";
import { LoadingIcon } from "../loader/loadingIcon";
import { DropdownIndicator, roundNumber, showToast } from "../../lib/helpers";
import { countries as payoutCountries } from "../../data/countries.js";
import Select from "react-select";
import toast from "react-hot-toast";
import TesterProfileNavigation from "../profile/tester_profile_navigation";
import Radiobtn from "../layouts/elements/fields/radiobtn.js";
import { LayoutTester } from "../themes/userq/Layouts/layout_tester";
import TopDeprecationBanner from "../TopDeprecationBanner";
import { PayoutOverviewBox } from "./components/payout_overview_box";
import { Text } from "../themes/userq/Text/Text";
import TesterAccountNavigation from "../profile/tester_account_navigation";
import { Icon } from "../themes/userq/Icon/Icon";
import { format } from "date-fns";
import { Button } from "../themes/userq/Button/Button";
import { getLoadMoreTesterHistory } from "../../services/test_result";
import AddBankAccountModal from "./components/add-bank-aacount";
import AddPaypalAccountModal from "./components/add-paypal-account";
import ConfirmationModal from "../themes/userq/Modal/ConfirmationModal";
import { useResetRecoilState, atom } from "recoil";
import { Link as UserQLink } from "../themes/userq/Link/Link.js";
import Skeleton from "react-loading-skeleton";
import { ScoreChip } from "../themes/userq/ScoreChip/ScoreChip";
import { VerifyId } from "../idVerification/VerifyId";
import DocumentNotMatch from "../themes/userq/Modal/DocumentNotMatch";
import { Box } from "../themes/userq/Box/Box";
import { ExpiryId } from "../idVerification/ExpiryId";
import { countries as sanctioned_countries } from "../../data/countries_sanctioned.js";

import { ToastMessage } from "../themes/userq/ToastMessage/ToastMessage";
import { Tag } from "../themes/userq/Tag/Tag.js";
import AddGiftCardModal from "./components/add-gift-card.js";
import InnerNavigationTab from "../themes/userq/InnernavigationTab/innerNavigationTab.js";

export default function Wallet() {
    const verifyIdRef = useRef(null);

    const scrollContainerRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const [bankFormValues, setBankFormValues] = useState({
        country: null,
        name: "",
        nickname: "",
        beneficiary_bank: "",
        branch: "",
        city: "",
        beneficiary_resident_country: null,
        account_no: "",
        account_no_type: "iban",
        type: "bank",
    });
    const [paypalFormValues, setPaypalFormValues] = useState({
        name: "",
        phone: "",
        email: "",
        type: "paypal",
    });
    const [bankFormErrors, setBankFormErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countryLabelClass, setCountryLabelClass] =
        useState("inactive_label");
    const [beneficiaryLabelClass, setBeneficiaryLabelClass] =
        useState("inactive_label");
    const [isBankAccountEditable, setIsBankAccountEditable] = useState(false);
    const [tempSelectedCountry, setTempSelectedCountry] = useState(null);
    const [tempBankFormValues, setTempBankFormValues] = useState({});
    const [minimumThresholdsForPayouts, setMinimumThresholdsForPayouts] =
        useState(0);
    const [payoutHistory, setPayoutHistory] = useState([]);
    const [loadMoreLoading, setLoadMoreLoading] = useState(false);

    const [openAddBankAccountModal, setOpenAddBankAccountModal] =
        useState(false);
    const [openAddPaypalModal, setOpenAddPaypalModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState({
        open: false,
    });
    const [confirmationBtnLoading, setConfirmationBtnLoading] = useState(false);

    let countrySelect = useRef(0);

    let beneficiaryCountrySelect = useRef(0);

    const [metaData, setMetaData] = useState({
        sort_status: "",
        sort_date: "",
        sort_method:"",
        load_more: false,
        page: 1,
        sort_method: "",
    });

    const navigate = useNavigate();

    const [credits, setCredits] = useState(null);
    const [requestedPayout, setRequestedPayout] = useState(null);
    const [depositedPayout, setDepositedPayout] = useState(null);
    let user = ReactSession.get("user");

    const [isProfileExpiredAt, setIsProfileExpiredAt] = useState("");

    const creditsState = atom({
        key: "credits",
        default: 0,
    });
    const reset = useResetRecoilState(creditsState);
    const [testerscore, setTesterScore] = useState(null);
    const [userBlocked, setUserBlocked] = useState(false);

    const accountstatus = ReactSession.get("accountstatus");
    let score = ReactSession.get("testerscore");

    const [isProfileVerified, setIsProfileVerified] = useState("");
    const [isProfileVerifiedAt, setIsProfileVerifiedAt] = useState("");
    const [isProfileAttempts, setIsProfileAttempts] = useState(0);

    const [documentNotMatch, setDocumentNotMatch] = useState({ open: false });

    const [displaySanctionedMessage, setDisplaySanctionedMessage] =
        useState(false);

    const [openGiftCardModal, setOpenGiftCardModal] = useState(false);
    const [isPayoutEnable, setPayoutEnable] = useState(false);
    const [isPaypalInfoAvailable, setPaypalInfoAvailable] = useState(false);
    const [isBankInfoAvailable, setBankInfoAvailable] = useState(false);
    const [modalType, setModalType] = useState("");
    const [userEmail, setUserEmail] = useState("");

    const handlePaymentModal = (modal) => {
        if (modal !== "banktransfer-edit" && modal !== "paypal-edit") {
            console.log(modal);

            if (isProfileVerified !== "verified") {
                verifyIdVerificationHandler();
                return false;
            }

            if (isProfileExpiredAt !== "" && isProfileExpiredAt === 0) {
                showToast(
                    "Please update your expired ID document before requesting a new payout.",
                    "error"
                );
                return false;
            }

            if (
                (credits >= minimumThresholdsForPayouts ||
                    requestedPayout + depositedPayout >=
                        minimumThresholdsForPayouts) &&
                credits >= minimumThresholdsForPayouts
            ) {
            } else {
                showToast("You can request payout after earning $30", "error");
                return false;
            }
            switch (modal) {
                case "giftcard":
                    setOpenGiftCardModal(true);
                    setModalType(modal);
                    break;
                case "paypal":
                    setOpenAddPaypalModal(true);
                    setModalType(modal);
                    break;
                case "banktransfer":
                    setOpenAddBankAccountModal(true);
                    setModalType(modal);
                    break;
                default:
                    break;
            }
        }else{
            switch (modal) {
            case "banktransfer-edit":
                    setOpenAddBankAccountModal(true);
                    setModalType(modal);
                    break;
            case "paypal-edit":
                    setOpenAddPaypalModal(true);
                    setModalType(modal);
                    break;
            }
        }

    };
    useEffect(() => {
        if (
            credits >= minimumThresholdsForPayouts &&
            isProfileVerified == "verified" &&
            !userBlocked
        ) {
            setPayoutEnable(true);
        } else {
            setPayoutEnable(false);
        }
    }, [credits, userBlocked, isProfileVerified]);

    useEffect(() => {
        document.title = "Your wallet | " + process.env.REACT_APP_NAME;

        let userData = ReactSession.get("user");
        // check profile is verified or not
        //setIsProfileVerified(userData.profile_verification_status);
        //setIsProfileVerifiedAt(userData.profile_verified_at);

        fetchCreditsSummary();
        gettesterbank();
        getProfieData();
    }, []);

    const handleScroll = () => {
        // Check the scroll position or any other logic you need
        const scrolled = scrollContainerRef.current.scrollTop > 0;

        // Update state based on the scroll position
        setIsScrolled(scrolled);
    };
    useEffect(() => {
        // Attach scroll event listener to the referenced element
        const scrollContainer = scrollContainerRef.current;

        if (scrollContainer) {
            scrollContainer.addEventListener("scroll", handleScroll);

            // Remove the event listener when the component unmounts
            return () => {
                scrollContainer.removeEventListener("scroll", handleScroll);
            };
        }
    }, [payoutHistory]);
    const getProfieData = () => {
        let token = ReactSession.get("token");
        setLoading(true);

        getProfile(token).then((response) => {
            setLoading(false);

            // check document not matched then open madal
            if (ReactSession.get("document_not_matched_model")) {
                setDocumentNotMatch({
                    open: true,
                });
                ReactSession.set("document_not_matched_model", false);
            }

            if (response.success) {
                // check profile is verified or not
                setIsProfileVerified(
                    response.data.user.profile_verification_status
                );
                setIsProfileVerifiedAt(response.data.user.verified_at);

                setIsProfileExpiredAt(
                    response.data.user.document_expiry_date_left
                );
                setIsProfileAttempts(
                    response.data.user.expired_document_attempt
                );
                setUserEmail(response.data.user.email);
            }
        });
    };

    const sortData = (type) => {
        if (type === "status") {
            if (metaData.sort_status === "asc") {
                sortDataApi("status", "desc");
            } else {
                sortDataApi("status", "asc");
            }
        } else if (type === "date") {
            if (metaData.sort_date === "asc") {
                sortDataApi("date", "desc");
            } else {
                sortDataApi("date", "asc");
            }
        } else if (type == "method") {
            if (metaData.sort_method === "asc") {
                sortDataApi("payout_method", "desc");
            } else {
                sortDataApi("payout_method", "asc");
            }
        }
    };

    const sortDataApi = (sortColumn, orderBy) => {
        let token = ReactSession.get("token");
        getLoadMoreWalletHistory(
            {
                page: 1,
                sort_column: sortColumn,
                order_by: orderBy,
            },
            token
        ).then((response) => {
            if (response.success) {
                setPayoutHistory(response.payoutHistory);

                if (sortColumn === "status") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_status: "desc",
                            sort_date: "",
                            sort_method:"",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_status: "asc",
                            sort_method:"",
                            sort_date: "",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                } else if (sortColumn === "date") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_status: "",
                            sort_method:"",
                            sort_date: "desc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_status: "",
                            sort_method:"",
                            sort_date: "asc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                } else if (sortColumn === "payout_method") {
                    if (orderBy === "desc") {
                        setMetaData({
                            ...metaData,
                            sort_status: "",
                            sort_date:"",
                            sort_method: "desc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    } else {
                        setMetaData({
                            ...metaData,
                            sort_status: "",
                            sort_date:"",
                            sort_method: "asc",
                            page: 1,
                            load_more: response.more_records,
                        });
                    }
                }
                // setMetaData({...metaData,page:metaData.page+1,load_more:response.more_records});
               
            } else {
                showToast(response.message, "error");
            }
        });
    };

    const loadMore = () => {
        setLoadMoreLoading(true);
        let token = ReactSession.get("token");
        getLoadMoreWalletHistory(
            {
                page: metaData.page + 1,
                sort_column: metaData.sort_status ? "status" : "date",
                order_by: metaData.sort_status ? metaData.sort_status : "desc",
            },
            token
        ).then((response) => {
            setLoadMoreLoading(false);

            if (response.success) {
                setPayoutHistory(payoutHistory.concat(response.payoutHistory));
                setMetaData({
                    ...metaData,
                    page: metaData.page + 1,
                    load_more: response.more_records,
                });
            } else {
                showToast(response.message, "error");
            }
        });
    };

    const fetchCreditsSummary = () => {
        if (!credits) {
            let token = ReactSession.get("token");

            setIsLoading(true);

            getTesterCreditSummaryService(token).then((response) => {
                setIsLoading(false);
                if (response.success) {
                    ReactSession.set(
                        "credits",
                        response.summary.credits_balance
                    );
                    setTesterScore(response.score);
                    if (response.account_status == "blocked") {
                        setUserBlocked(true);
                    }
                    setCredits(response.summary.credits_balance);
                    setRequestedPayout(response.summary.requestedpayoutamount);
                    setDepositedPayout(response.summary.depositedpayoutamount);
                }
            });
        }
    };

    const requestpayout = (method, details = null) => {
        if (loading) {
            return;
        }
        // check user id is verified
        if (isProfileVerified !== "verified") {
            verifyIdVerificationHandler();
            return false;
        }

        if (isProfileExpiredAt !== "" && isProfileExpiredAt === 0) {
            showToast(
                "Please update your expired ID document before requesting a new payout.",
                "error"
            );
            return false;
        }

        if (
            (credits >= minimumThresholdsForPayouts ||
                requestedPayout + depositedPayout >=
                    minimumThresholdsForPayouts) &&
            credits >= minimumThresholdsForPayouts
        ) {
        } else {
            showToast("You can request payout after earning $30", "error");
            return false;
        }
        /*  if(method !== "Gift card"){
            if(!checkBankDetailsEntered()){
                showToast("Add your bank/paypal account to request payout", "error");
                return false;
            }

        } */

        // (((credits >= minimumThresholdsForPayouts) || (requestedPayout + depositedPayout >= minimumThresholdsForPayouts))
        //     && (credits >= minimumThresholdsForPayouts))
        //     ? (checkBankDetailsEntered()) ? requestpayout : false : false

        setLoading(true);

        var toast_message = "";

        if (method == "PayPal") {
            toast_message =
                "Your payout request has been submitted successfully! Your payment should be processed within 15 business days. If there is an issue, we will contact you via email.";
        } else if (method == "Bank transfer") {
            toast_message =
                "Your payout request has been submitted successfully! Your payment should be processed within 30 business days. If there is an issue, we will contact you via email.";
        } else {
            toast_message =
                "Your payout request has been submitted successfully! You will receive the digital gift card to your registered email within 2 business days. If there is an issue, we will contact you via email.";
        }

        const token = ReactSession.get("token");
        var data = {};
        if (details !== null) {
            data["bankdetails"] = details;
        }
        data["selectedbankcountry"] = bankFormValues.country;
        data["amount"] = credits;
        data["payout_method"] = method;
        /*  var data = new FormData();
         data.append("bankdetails", JSON.stringify(bankFormValues));
        data.append("selectedbankcountry", selectedCountry); 
        data.append("amount", credits);
        data.append("payout_method", method); */
        requesttesterpayout(data, token).then((response) => {
            

            setLoading(false);
            if (response.success) {

                setCredits(response.balance);
                setRequestedPayout(response.requestedpayoutamount);
                setDepositedPayout(response.depositedpayoutamount);
                reset();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "request_payout",
                    method: response.type,
                    value: response.requestedpayoutamount,
                    userID: ReactSession.get("user")
                        ? ReactSession.get("user").user_id
                        : "",
                });
                gettesterbank();
                setOpenGiftCardModal(false);
                setOpenAddPaypalModal(false);
                setOpenAddBankAccountModal(false);

                showToast(toast_message, "success");
            } else {

                if("error_code" in response){
                    if(response.error_code=="amount validation failed"){
                        showToast(<>Gift cards cannot be issued for orders above $2000. Please contact <a href="mailto://support@userq.com">support@userq.com</a> for assistance.</>,"error");
                    } else if(response.error_code=="insufficient funds"){
                        
                        showToast(<>Something went wrong on our end. Please contact <a href="mailto://support@userq.com">support@userq.com</a> for assistance.</>,"error");
                    } else {
                        showToast(response.message, "error");
                    }
                } else {
                    showToast(response.message, "error");
                }
            }
        });
    };

    const resetFormErrors = () => {
        let formErrorsLocal = Object.assign({}, bankFormErrors);

        for (var key in bankFormErrors) {
            formErrorsLocal[key] = null;
        }
        setBankFormErrors(formErrorsLocal);

        return formErrorsLocal;
    };

    const validateBankDetails = () => {
        var error = false;

        var form_errors = resetFormErrors();

        var firsterrorid = null;

        if (!bankFormValues.country) {
            form_errors = {
                ...form_errors,
                country: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid = firsterrorid == null ? "country" : firsterrorid;
        }
        if (bankFormValues.name == "") {
            form_errors = {
                ...form_errors,
                name: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid = firsterrorid == null ? "name" : firsterrorid;
        }
        if (bankFormValues.beneficiary_bank == "") {
            form_errors = {
                ...form_errors,
                beneficiary_bank: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid =
                firsterrorid == null ? "beneficiary_bank" : firsterrorid;
        }
        if (bankFormValues.branch == "") {
            form_errors = {
                ...form_errors,
                branch: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid = firsterrorid == null ? "branch" : firsterrorid;
        }
        if (bankFormValues.city == "") {
            form_errors = {
                ...form_errors,
                city: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid = firsterrorid == null ? "city" : firsterrorid;
        }
        if (!bankFormValues.beneficiary_resident_country) {
            form_errors = {
                ...form_errors,
                beneficiary_resident_country: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid =
                firsterrorid == null
                    ? "beneficiary_resident_country"
                    : firsterrorid;
        }
        if (!bankFormValues.account_no) {
            form_errors = {
                ...form_errors,
                account_no: "Required!",
                error_class: "input_error",
            };
            error = true;
            firsterrorid = firsterrorid == null ? "account_no" : firsterrorid;
        }
        setBankFormErrors(form_errors);

        /*if(firsterrorid!=null){
            document.getElementById(firsterrorid).scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
        }*/

        return error;
    };

    const updatebankdetails = () => {
        var error = validateBankDetails();
        if (!error) {
            setLoading(true);
            const token = ReactSession.get("token");
            var data = new FormData();
            data.append("bankdetails", JSON.stringify(bankFormValues));
            data.append("selectedbankcountry", bankFormValues.country);
            updatetesterbankdetails(data, token).then((response) => {
                setLoading(false);
                if (response.success) {
                    gettesterbank();
                    setIsBankAccountEditable(false);

                    toast(
                        <div className="toastinner">
                            Your Bank account details have been updated
                            successfully
                            <a
                                onClick={() => {
                                    toast.dismiss();
                                }}
                            >
                                &times;
                            </a>
                        </div>,
                        {
                            className: "successtoast",
                            position: "bottom-center",
                            duration: 5000,
                        }
                    );
                } else {
                    toast(
                        <div className="toastinner">
                            {response.message}
                            <a
                                onClick={() => {
                                    toast.dismiss();
                                }}
                            >
                                &times;
                            </a>
                        </div>,
                        {
                            className: "errortoast",
                            position: "bottom-center",
                            duration: 5000,
                        }
                    );
                    // console.log(response);
                }
            });
        }
    };

    const gettesterbank = () => {
        const token = ReactSession.get("token");
        gettesterbankdetails(token).then((response) => {
            if (response.success) {
                console.log(response);

                setPayoutHistory(response.payoutHistory);

                // setIsProfileExpiredAt(response.document_expiry_date_left);
                // setIsProfileAttempts(response.expired_document_attempt);

                setMetaData({
                    sort_status: "",
                    sort_date: "",
                    sort_reward: "",
                    sort_method: "",
                    load_more: response.result_count > 10 ? true : false,
                    page: 1,
                });

                setMinimumThresholdsForPayouts(
                    parseInt(response.minimum_thresholds_for_payouts)
                );

                var sanctioned_country = false;

                sanctioned_countries.forEach(function (country) {
                    if (response.country == country.value) {
                        sanctioned_country = true;
                    }
                });
                setDisplaySanctionedMessage(sanctioned_country);

                if (response.bankdetails != null) {
                    /*  if (response.bankdetails.type && response.bankdetails.type === 'paypal') { */

                    setPaypalFormValues({
                        name: response.bankdetails.name
                            ? response.bankdetails.name
                            : null,
                        phone: response.bankdetails.phone
                            ? response.bankdetails.phone
                            : null,
                        email: response.email ? response.email : null,
                        beneficiary_resident_country: response.country
                            ? response.country
                            : null,
                        type: "paypal",
                    });

                    setBankFormValues({
                        ...bankFormErrors,
                        type: "paypal",
                    });
                    /* } else { */

                    setBankFormValues({
                        country: response.bankdetails.country
                            ? response.bankdetails.country
                            : null,
                        // name: response.bankdetails.name ? response.bankdetails.name : '',
                        name: user.first_name + " " + user.last_name,
                        nickname: response.bankdetails.nickname
                            ? response.bankdetails.nickname
                            : "",
                        beneficiary_bank: response.bankdetails.beneficiary_bank
                            ? response.bankdetails.beneficiary_bank
                            : "",
                        branch: response.bankdetails.branch
                            ? response.bankdetails.branch
                            : "",
                        city: response.bankdetails.city
                            ? response.bankdetails.city
                            : "",
                        beneficiary_resident_country: response.country
                            ? response.country
                            : null,
                        // beneficiary_resident_country: response.bankdetails.beneficiary_resident_country ? response.bankdetails.beneficiary_resident_country : null,
                        account_no_type: response.bankdetails.account_no_type
                            ? response.bankdetails.account_no_type
                            : "iban",
                        account_no: response.bankdetails.account_no
                            ? response.bankdetails.account_no
                            : "",
                        type: "bank",
                    });

                    /* } */
                    if (response.bankdetails.phone) {
                        setPaypalInfoAvailable(true);
                    }
                    if (response.bankdetails.account_no) {
                        setBankInfoAvailable(true);
                    }
                } else {
                    setBankFormValues({
                        ...bankFormValues,
                        name: user.first_name + " " + user.last_name,
                        beneficiary_resident_country: response.country
                            ? response.country
                            : null,
                    });

                    setPaypalFormValues({
                        ...paypalFormValues,
                        email: response.email ? response.email : null,
                        beneficiary_resident_country: response.country
                            ? response.country
                            : null,
                    });
                }
            } else {
                showToast(response.message, "error");
                // console.log(response);
            }
        });
    };

    // const countryChange = (item) => {
    //     setBankFormValues({...bankFormValues, country:item.value});
    //     setCountryLabelClass("active_label");
    //     setBankFormErrors({...bankFormErrors,country:null});
    //
    // };
    // const beneficiaryCountryChange = (item) => {
    //     setBeneficiaryLabelClass("active_label");
    //     setBankFormErrors({...bankFormErrors,beneficiary_resident_country:null});
    //
    //     if(item.value=="United Arab Emirates"){
    //         setBankFormValues({...bankFormValues, account_no_type:"iban", beneficiary_resident_country:item.value});
    //     } else {
    //         setBankFormValues({...bankFormValues, beneficiary_resident_country:item.value});
    //
    //     }
    //
    // };
    const checkBankDetailsEntered = () => {
        if (bankFormValues.type === "paypal") {
            if (
                paypalFormValues.name &&
                paypalFormValues.email &&
                paypalFormValues.phone
            ) {
                return true;
            }
        } else {
            if (
                bankFormValues.country &&
                bankFormValues.name &&
                bankFormValues.beneficiary_bank &&
                bankFormValues.branch &&
                bankFormValues.city &&
                bankFormValues.beneficiary_resident_country &&
                bankFormValues.account_no
            ) {
                return true;
            }
        }

        return false;
    };

    const deleteBankAccountApi = (accountType) => {
        setConfirmationBtnLoading(true);
        const token = ReactSession.get("token");
        var data = {};
        data["payout_method"] = accountType;
        deletetesterbankdetails(data, token).then((response) => {
            setConfirmationBtnLoading(false);
            if (response.success) {
                setConfirmModal({ open: false });

                // console.log(accountType)
                if (accountType === "PayPal") {
                    setPaypalFormValues({
                        ...paypalFormValues,
                        name: "",
                        phone: "",
                        type: "paypal",
                    });

                    showToast(
                        " Your paypal account details have been deleted successfully",
                        "success"
                    );

                    setPaypalInfoAvailable(false);
                } else {
                    setBankFormValues({
                        ...bankFormValues,
                        country: null,
                        nickname: "",
                        beneficiary_bank: "",
                        branch: "",
                        city: "",
                        account_no: "",
                        account_no_type: "iban",
                        type: "bank",
                    });

                    showToast(
                        " Your bank account details have been deleted successfully",
                        "success"
                    );
                    setBankInfoAvailable(false);
                }
            } else {
                showToast(response.message, "error");
            }
        });
    };

    const confirmHandlerAsas = () => {};
    //  verify id veryfication handler
    const verifyIdVerificationHandler = () => {
        // showToast(<>ID verification is required for payout. Verify your identity</>,"error")
        if (
            isProfileVerified === "id_not_matched_profile" ||
            isProfileVerified === "unverified" ||
            (isProfileVerified === "expired_document" &&
                isProfileExpiredAt === "") ||
            isProfileVerified === "invalid_document"
        ) {
            verifyIdRef.current.handleToastMessage(
                isProfileVerified,
                isProfileVerifiedAt
            );
        }
    };
    return (
        <LayoutTester
            isLoading={false}
            skipCheck={false}
            isAccount={true}
            extendedFooter={false}
            activeMenu={"wallet"}
            wrapClass={"xxl-px-240"}
        >
            <TopDeprecationBanner />
            <div className="credits-page-wrapper wallet-page-wrapper page-min-height">
                {accountstatus == "blocked" && (
                    <div className="account-blocked-message">
                        <div>
                            <Icon
                                colorClass={"danger-red-200"}
                                value={"blocked"}
                                size="large"
                            />
                        </div>
                        <div>
                            <Text
                                type={"subtitle-1"}
                                children="Your payout cannot be redeemed as your profile is currently blocked."
                            />
                            <Text type={"body-text-2"}>
                                Please contact{" "}
                                <a
                                    className="faq-support-link disabled-support-link"
                                    href={
                                        process.env.REACT_APP_URL +
                                        "t/support/contact?reason=Blocked profile"
                                    }
                                    target="_blank"
                                >
                                    UserQ support
                                </a>
                                , to guide you through the next steps.
                            </Text>
                        </div>
                    </div>
                )}
                <div className="page-heading-wrap accounts-page--heading">
                    <Text type="h1">Account</Text>
                    <div className="accounts-score-chip">
                        {/* {isLoading?<Skeleton className="header-credit-skeleton" width={180} height={40}/>:<ScoreChip testerscore={testerscore}/>} */}
                        <ScoreChip testerscore={score} />
                        <div className="account-guidelines-link">
                            <Text type="body-text-3">
                                Read more about{" "}
                                <a
                                    className="faq-support-link"
                                    href={
                                        process.env.REACT_APP_URL +
                                        "t/tester-guidelines"
                                    }
                                    target="_blank"
                                >
                                    tester guidelines
                                </a>
                            </Text>
                        </div>
                    </div>
                </div>
                <InnerNavigationTab
                    type="link" 
                    activeMenu={"wallet"} 
                    cssClasses={"mb-32 "}
                    items={[
                        { key: "profile", label: "Your profile", link: "/t/profile" },
                        { key: "tests", label: "Test history", link: "/t/test-history" },
                        { key: "wallet", label: "Wallet", link: "/t/wallet" },
                        { key: "settings", label: "Notification settings", link: "/t/settings" }
                    ]}
                />

                <div className="profile-info-section d-block pb-64 pt-64 wallet-page-data">
                    <div className="data-container">
                        {/*<div className="profile-info-left w-100">*/}
                        {/*    <div className="profile-info-text  mt-0">*/}
                        {/*        <h1 className="page-main-heading">Wallet</h1>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {isLoading ? (
                            <div className="accountloading-box">
                                <LoadingIcon />
                            </div>
                        ) : (
                            <>
                                <div className="wallet-top-wrap mt-40">
                                    {(isProfileVerified ===
                                        "id_not_matched_profile" ||
                                        isProfileVerified === "unverified" ||
                                        (isProfileVerified ===
                                            "expired_document" &&
                                            isProfileExpiredAt === "") ||
                                        isProfileVerified ===
                                            "invalid_document") && (
                                        <div className="idverify-message mb-32">
                                            <VerifyId
                                                ref={verifyIdRef}
                                                isType={"banner"}
                                                isProfileVerifiedAt={
                                                    isProfileVerifiedAt
                                                }
                                                isProfileVerified={
                                                    isProfileVerified
                                                }
                                                confirmHandler={(status) => {
                                                    if (status) {
                                                        navigate("/dashboard");
                                                    } else {
                                                        navigate("/t/profile");
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}

                                    {(isProfileVerified === "verified" ||
                                        isProfileVerified ===
                                            "expired_document") &&
                                        isProfileExpiredAt !== "" &&
                                        isProfileExpiredAt >= 0 && (
                                            <div
                                                className={`idexpiry-message ${
                                                    displaySanctionedMessage
                                                        ? "mb-20"
                                                        : "mb-32"
                                                } `}
                                            >
                                                <ExpiryId
                                                    profileExpiredDate={
                                                        isProfileExpiredAt
                                                    }
                                                    isProfileAttempts={
                                                        isProfileAttempts
                                                    }
                                                    isProfileVerifiedAt={
                                                        isProfileVerifiedAt
                                                    }
                                                    confirmHandler={() => {
                                                        navigate("/t/profile");
                                                    }}
                                                />
                                            </div>
                                        )}
                                    {displaySanctionedMessage && (
                                        <div className="formbox sanctioned-info mb-32">
                                            <div className=" input-field  input-with-right-icon mb-0  ">
                                                <ToastMessage
                                                    closable={false}
                                                    type={"warning"}
                                                    message={
                                                        <>
                                                            In compliance with
                                                            both local and
                                                            international
                                                            regulations, we may
                                                            not be able to
                                                            process payouts to
                                                            certain countries.
                                                            Please refer to our{" "}
                                                            <UserQLink
                                                                target="_blank"
                                                                url="https://userq.com/terms-of-use"
                                                            >
                                                                Terms of use
                                                            </UserQLink>
                                                            .
                                                        </>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4">
                                            {userBlocked ? (
                                                <PayoutOverviewBox
                                                    amount={roundNumber(
                                                        credits,
                                                        2
                                                    )}
                                                    type="balance"
                                                    request_payout_enabled={
                                                        false
                                                    }
                                                    onClick={() => {}}
                                                    loading={loading}
                                                />
                                            ) : (
                                                <PayoutOverviewBox
                                                    amount={roundNumber(
                                                        credits,
                                                        2
                                                    )}
                                                    type="balance"
                                                    request_payout_enabled={
                                                        (credits >=
                                                            minimumThresholdsForPayouts ||
                                                            requestedPayout +
                                                                depositedPayout >=
                                                                minimumThresholdsForPayouts) &&
                                                        credits >=
                                                            minimumThresholdsForPayouts
                                                            ? checkBankDetailsEntered()
                                                                ? true
                                                                : false
                                                            : false
                                                    }
                                                    onClick={requestpayout}
                                                    loading={loading}
                                                />
                                            )}
                                        </div>
                                        <div className="col-lg-4 col-md-4">
                                            <PayoutOverviewBox
                                                amount={roundNumber(
                                                    requestedPayout,
                                                    2
                                                )}
                                                type="inprogress"
                                            />
                                        </div>

                                        <div className="col-lg-4 col-md-4">
                                            <PayoutOverviewBox
                                                amount={roundNumber(
                                                    depositedPayout,
                                                    2
                                                )}
                                                type="deposited"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-40">
                                    <div className="payment-method-heading">
                                        <Text
                                            type={"subtitle-2"}
                                            fontWeight={"semi-bold-font"}
                                        >
                                            Choose payout method
                                        </Text>
                                        <Text
                                            type={"body-text-2"}
                                            fontWeight={"medium-font"}
                                            cssClasses={"gray-text mt-12"}
                                        >
                                            You can request a payout once your
                                            wallet balance reaches a minimum of
                                            $30.
                                        </Text>
                                    </div>
                                    <div className="mt-32 payment-methods-wrapper">
                                        <div className="payment-method-box">
                                            <div className="payment-box-img">
                                                <img
                                                    src={
                                                        process.env
                                                            .REACT_APP_URL +
                                                        "img/payment-cards.png"
                                                    }
                                                    alt="img"
                                                />
                                            </div>
                                            <div className="payment-box-content p-20">
                                                <div className="d-flex justify-content-between">
                                                    <Text
                                                        type={"subtitle-2"}
                                                        fontWeight={
                                                            "semi-bold-font"
                                                        }
                                                    >
                                                        Digital gift card
                                                    </Text>
                                                    <Tag
                                                        type="purple-tag"
                                                        title={"Recommended"}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <Icon
                                                        value={"time"}
                                                        color={"gray-700-svg"}
                                                        cssClasses={"mr-8"}
                                                    />
                                                    <Text
                                                        type={"body-text-3"}
                                                        fontWeight={
                                                            "medium-font"
                                                        }
                                                        cssClasses={"gray-text"}
                                                    >
                                                        Within 2 days
                                                    </Text>
                                                </div>
                                                <Text
                                                    type={"caption"}
                                                    cssClasses={"mt-20 d-block"}
                                                >
                                                    Choose from a variety of
                                                    retailers
                                                </Text>
                                                <Button
                                                    onClick={() => {
                                                        handlePaymentModal(
                                                            "giftcard"
                                                        );
                                                    }}
                                                    type={"primary"}
                                                    size={"small"}
                                                    cssclass={
                                                        "mt-20 btn-block justify-content-center"
                                                    }
                                                    label={"Select"}
                                                    state={
                                                        isPayoutEnable
                                                            ? "active"
                                                            : "disabled"
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="payment-method-box">
                                            <div className="payment-box-img">
                                                <img
                                                    src={
                                                        process.env
                                                            .REACT_APP_URL +
                                                        "img/payment-paypal.png"
                                                    }
                                                    alt="img"
                                                />
                                            </div>
                                            <div className="payment-box-content p-20">
                                                <div className="d-flex justify-content-between mb-8">
                                                    <Text
                                                        type={"subtitle-2"}
                                                        fontWeight={
                                                            "semi-bold-font"
                                                        }
                                                    >
                                                        PayPal
                                                    </Text>
                                                    {isPaypalInfoAvailable && (
                                                        <Icon
                                                            value={"edit"}
                                                            size={"medium"}
                                                            hover={true}
                                                            color={
                                                                "gray-900-svg"
                                                            }
                                                            cssClasses={
                                                                "cursor-pointer"
                                                            }
                                                            onClick={() => {
                                                                handlePaymentModal(
                                                                    "paypal-edit"
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <Icon
                                                        value={"time"}
                                                        color={"gray-700-svg"}
                                                        cssClasses={"mr-8"}
                                                    />
                                                    <Text
                                                        type={"body-text-3"}
                                                        fontWeight={
                                                            "medium-font"
                                                        }
                                                        cssClasses={"gray-text"}
                                                    >
                                                        Within 15 days
                                                    </Text>
                                                </div>
                                                <Text
                                                    type={"caption"}
                                                    cssClasses={"mt-20 d-block"}
                                                >
                                                    Transfer to your PayPal
                                                    account
                                                </Text>
                                                <Button
                                                    onClick={() => {
                                                        handlePaymentModal(
                                                            "paypal"
                                                        );
                                                    }}
                                                    type={"primary"}
                                                    size={"small"}
                                                    cssclass={
                                                        "mt-20 btn-block justify-content-center"
                                                    }
                                                    label={"Select"}
                                                    state={
                                                        isPayoutEnable
                                                            ? "active"
                                                            : "disabled"
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="payment-method-box">
                                            <div className="payment-box-img">
                                                <img
                                                    src={
                                                        process.env
                                                            .REACT_APP_URL +
                                                        "img/payment-bank.png"
                                                    }
                                                    alt="img"
                                                />
                                            </div>
                                            <div className="payment-box-content p-20">
                                                <div className="d-flex justify-content-between mb-8">
                                                    <Text
                                                        type={"subtitle-2"}
                                                        fontWeight={
                                                            "semi-bold-font"
                                                        }
                                                    >
                                                        Bank Transfer
                                                    </Text>
                                                    {isBankInfoAvailable && (
                                                        <Icon
                                                            value={"edit"}
                                                            size={"medium"}
                                                            hover={true}
                                                            color={
                                                                "gray-900-svg"
                                                            }
                                                            cssClasses={
                                                                "cursor-pointer"
                                                            }
                                                            onClick={() => {
                                                                handlePaymentModal(
                                                                    "banktransfer-edit"
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <Icon
                                                        value={"time"}
                                                        color={"gray-700-svg"}
                                                        cssClasses={"mr-8"}
                                                    />
                                                    <Text
                                                        type={"body-text-3"}
                                                        fontWeight={
                                                            "medium-font"
                                                        }
                                                        cssClasses={"gray-text"}
                                                    >
                                                        Within 30 days
                                                    </Text>
                                                </div>
                                                <Text
                                                    type={"caption"}
                                                    cssClasses={"mt-20 d-block"}
                                                >
                                                    Direct deposit to your bank
                                                    account
                                                </Text>
                                                <Button
                                                    onClick={() => {
                                                        handlePaymentModal(
                                                            "banktransfer"
                                                        );
                                                    }}
                                                    type={"primary"}
                                                    size={"small"}
                                                    cssclass={
                                                        "mt-20 btn-block justify-content-center"
                                                    }
                                                    label={"Select"}
                                                    state={
                                                        isPayoutEnable
                                                            ? "active"
                                                            : "disabled"
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*  old design */}

                                {/*Payout histoty table*/}
                                <div className="table-wrapper study-history-table wallet-payout-history-table mt-32">
                                    {payoutHistory.length > 0 && (
                                        <Text type={"h4"}>Payouts history</Text>
                                    )}

                                    <div
                                        ref={scrollContainerRef}
                                        className={`max-height-table  ${
                                            isScrolled ? "scrolled" : ""
                                        }  ${
                                            payoutHistory &&
                                            payoutHistory.length > 8
                                                ? "responsive-table-scroll"
                                                : ""
                                        }`}
                                    >
                                        <table className="table">
                                            {payoutHistory.length > 0 ? (
                                                <thead>
                                                    <tr>
                                                        <th>Amount</th>
                                                        <th className="">
                                                            <div className="table-center-div">
                                                                <div
                                                                    onClick={() => {
                                                                        sortData(
                                                                            "status"
                                                                        );
                                                                    }}
                                                                    className={`${
                                                                        metaData.sort_status
                                                                            ? metaData.sort_status
                                                                            : ""
                                                                    }  col-sort justify-content-between`}
                                                                >
                                                                    Status
                                                                    <span>
                                                                        {metaData.sort_status ==
                                                                            "asc" && (
                                                                            <Icon
                                                                                value={
                                                                                    "sortup"
                                                                                }
                                                                            />
                                                                        )}
                                                                        {metaData.sort_status ==
                                                                            "desc" && (
                                                                            <Icon
                                                                                value={
                                                                                    "sortdown"
                                                                                }
                                                                            />
                                                                        )}
                                                                        {!metaData.sort_status && (
                                                                            <Icon
                                                                                value={
                                                                                    "sort-icon"
                                                                                }
                                                                            />
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div
                                                                onClick={() => {
                                                                    sortData(
                                                                        "method"
                                                                    );
                                                                }}
                                                                className={`${
                                                                    metaData.sort_method
                                                                        ? metaData.sort_method
                                                                        : ""
                                                                }  col-sort justify-content-between`}
                                                            >
                                                                Payout Method
                                                                <span>
                                                                    {metaData.sort_method ==
                                                                        "asc" && (
                                                                        <Icon
                                                                            value={
                                                                                "sortup"
                                                                            }
                                                                        />
                                                                    )}
                                                                    {metaData.sort_method ==
                                                                        "desc" && (
                                                                        <Icon
                                                                            value={
                                                                                "sortdown"
                                                                            }
                                                                        />
                                                                    )}
                                                                    {!metaData.sort_method && (
                                                                        <Icon
                                                                            value={
                                                                                "sort-icon"
                                                                            }
                                                                        />
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div
                                                                onClick={() => {
                                                                    sortData(
                                                                        "date"
                                                                    );
                                                                }}
                                                                className={`${
                                                                    metaData.sort_date
                                                                        ? metaData.sort_date
                                                                        : ""
                                                                }  col-sort justify-content-between`}
                                                            >
                                                                Date
                                                                <span>
                                                                    {metaData.sort_date ==
                                                                        "asc" && (
                                                                        <Icon
                                                                            value={
                                                                                "sortup"
                                                                            }
                                                                        />
                                                                    )}
                                                                    {metaData.sort_date ==
                                                                        "desc" && (
                                                                        <Icon
                                                                            value={
                                                                                "sortdown"
                                                                            }
                                                                        />
                                                                    )}
                                                                    {!metaData.sort_date && (
                                                                        <Icon
                                                                            value={
                                                                                "sort-icon"
                                                                            }
                                                                        />
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                            ) : (
                                                ""
                                            )}
                                            <tbody>
                                                {payoutHistory.map(
                                                    (result, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    $
                                                                    {roundNumber(
                                                                        result.amount,
                                                                        2
                                                                    )}
                                                                </td>
                                                                <td className="">
                                                                    <div className="table-center-div">
                                                                        <div className="active-tiles-wrap">
                                                                            {result.status ===
                                                                                "deposited" && (
                                                                                <span
                                                                                    className={
                                                                                        "completed"
                                                                                    }
                                                                                >
                                                                                    Completed
                                                                                </span>
                                                                            )}
                                                                            {result.status ===
                                                                                "in-progress" && (
                                                                                <span
                                                                                    className={
                                                                                        "in-progress"
                                                                                    }
                                                                                >
                                                                                    In-progress
                                                                                </span>
                                                                            )}
                                                                            {result.status ===
                                                                                "cancelled" && (
                                                                                <span
                                                                                    className={
                                                                                        "cancelled"
                                                                                    }
                                                                                >
                                                                                    Cancelled
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {
                                                                        result.payout_method
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {format(
                                                                        new Date(
                                                                            result.created_at
                                                                        ),
                                                                        "dd/MM/yy"
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>

                                        {metaData.load_more && (
                                            <div className={"load-more-data"}>
                                                <Button
                                                    type="primary"
                                                    size={`large`}
                                                    label="Load more"
                                                    microLoading={
                                                        loadMoreLoading
                                                    }
                                                    onClick={() => {
                                                        loadMore();
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <AddBankAccountModal
                openModal={openAddBankAccountModal}
                type={modalType}
                isloading={loading}
                closeModal={(status, bankFormData) => {
                    if (status) {
                        setBankFormValues({
                            country: bankFormData.country,
                            name: user.first_name + " " + user.last_name,
                            nickname: bankFormData.nickname,
                            beneficiary_bank: bankFormData.beneficiary_bank,
                            branch: bankFormData.branch,
                            city: bankFormData.city,
                            beneficiary_resident_country:
                                bankFormData.beneficiary_resident_country,
                            account_no: bankFormData.account_no,
                            account_no_type: bankFormData.account_no_type,
                            type: "bank",
                        });
                    }
                    setOpenAddBankAccountModal(false);
                }}
                bankFormValuesData={bankFormValues}
                requestPayout={(details) => {
                    requestpayout("Bank transfer", details);
                }}
                requestDelete={() => {
                    setOpenAddBankAccountModal(false);
                    setConfirmModal({
                        open: true,
                        confirm_btn_title: "Yes, remove",
                        cancel_btn_title: "No, keep",
                        confirm_title: "Remove bank account",
                        confirm_message:
                            "Are you sure you want to delete your bank account details?",
                        confirmation_for: "bankAccountdelete",
                        confirm_title_class: "text-danger",
                    });
                }}
            />
            <AddPaypalAccountModal
                openModal={openAddPaypalModal}
                isloading={loading}
                type={modalType}
                closeModal={(status, bankFormData) => {
                    if (status) {
                        setPaypalFormValues({
                            name: bankFormData.name,
                            phone: bankFormData.phone,
                            email: bankFormData.email,
                            type: "paypal",
                        });
                        setBankFormValues({
                            ...bankFormValues,
                            type: "paypal",
                        });
                    }
                    setOpenAddPaypalModal(false);
                }}
                bankFormValuesData={paypalFormValues}
                requestPayout={(details) => {
                    requestpayout("PayPal", details);
                }}
                requestDelete={() => {
                    setOpenAddPaypalModal(false);
                    setConfirmModal({
                        open: true,
                        confirm_btn_title: "Yes, remove",
                        cancel_btn_title: "No, keep",
                        confirm_title: "Remove Paypal account",
                        confirm_message:
                            "Are you sure you want to delete your PayPal account details?",
                        confirmation_for: "paypalAccountdelete",
                        confirm_title_class: "text-danger",
                    });
                }}
            />
            <ConfirmationModal
                confirm_message={confirmModal.confirm_message}
                confirm_btn_title={confirmModal.confirm_btn_title}
                cancel_btn_title={confirmModal.cancel_btn_title}
                confirm_title={confirmModal.confirm_title}
                confirm_title_class={confirmModal.confirm_title_class}
                btn_reverse={true}
                openModal={confirmModal.open}
                btnLoading={confirmationBtnLoading}
                close={() => {
                    setConfirmModal({ ...confirmModal, open: false });
                }}
                confirm={() => {
                    // setConfirmModal({ ...confirmModal, open: false });
                    if (confirmModal.confirmation_for === "bankAccountdelete") {
                        deleteBankAccountApi("Bank transfer");
                    } else if (
                        confirmModal.confirmation_for === "paypalAccountdelete"
                    ) {
                        deleteBankAccountApi("PayPal");
                    }
                }}
            />
            <DocumentNotMatch
                confirm_title={
                    "We need to update your profile to match your ID"
                }
                openModal={documentNotMatch.open}
                close={() => {
                    setDocumentNotMatch({ open: false });
                }}
                confirmHandler={(status) => {
                    if (status) {
                        navigate("/dashboard");
                    } else {
                        navigate("/t/profile");
                    }
                }}
            />
            <AddGiftCardModal
                openModal={openGiftCardModal}
                closeModal={() => {
                    setOpenGiftCardModal(false);
                }}
                amount={roundNumber(credits, 2)}
                requestPayout={() => requestpayout("Gift card")}
                isLoading={loading}
                userEmail={userEmail}
            />
        </LayoutTester>
    );
}
